import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["placeholder"];
import React, { useMemo } from 'react';
import { Input, createUseStyles } from '@Sage/hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ColorPicker');
function ColorPicker(_ref) {
  let {
      placeholder
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const classes = useStyles();
  const overrides = useMemo(() => ({
    postComponent: {
      className: classes.postComponent
    },
    formControl: {
      className: classes.formControl
    },
    inputComponents: {
      className: classes.inputComponents
    },
    input: {
      className: classes.input
    }
  }), [classes.postComponent, classes.formControl, classes.inputComponents, classes.input]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, _extends({
    labelMode: "horizontal",
    type: "color",
    overrides: overrides
  }, props)));
}
export default ColorPicker;